module.exports = __webpack_public_path__ + "img/events-mobile.377c03c1.jpg";